module.exports = __webpack_public_path__ + "img/Banner-Website-DAB-Presentation.75b99885.jpg";